import { render, staticRenderFns } from "./PageNum.vue?vue&type=template&id=d66669a2"
import script from "./PageNum.vue?vue&type=script&lang=js"
export * from "./PageNum.vue?vue&type=script&lang=js"
import style0 from "./PageNum.vue?vue&type=style&index=0&id=d66669a2&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports